/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo button
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var Button = kendo.ui.Button;
    if (!Button || Button.updated) return;

    Button = Button.extend({
        // new init
        init: kendo.getGenericInit(Button),
        // default options extension
        options: kendo.getUpdatedWidgetOptions()
    });

    Button.updated = true;

    kendo.ui.plugin(Button);

})(window.kendo.jQuery);
